/**
 * @generated SignedSource<<311827b5b8d0ac7a6ddc2644637aa7fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontContactButton_seller$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "StorefrontContactButton_seller";
};
export type StorefrontContactButton_seller$key = {
  readonly " $data"?: StorefrontContactButton_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontContactButton_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontContactButton_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "e40e078ed7e25c3329a991d14ec00f41";

export default node;
